const initialState = { delivery_type: 3, currency_id: 1, format: 1, deliveryType: [] as any, new: true };

export const reducer = (state = { ...initialState, deliveryType: [] as any }, action: any) => {
  switch (action.type) {
    case 'CHANGE_PHYSICAL_DELIVERY':
      return Object.assign({}, action.delivery);
    case 'RESET_PHYSICAL_DELIVERY':
      return { ...initialState, deliveryType: [] as any };
    default:
      return state;
  }
};
